module.exports = __webpack_public_path__ + "static/yochlol-070fa1c37a2173c8154cb5b3946cfa38.jpg";